export const CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_SUCCESS = 'CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_SUCCESS';

export const createStatementTemplatePlaceholderSuccess = ({ statementTemplatePlaceholder }) => ({
    type: CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_SUCCESS,
    payload: {
        statementTemplatePlaceholder,
    }
});
